// eslint-disable-next-line import/no-cycle
import {
  GetScheme,
  SetScheme,
  GetProviderFeatures,
  UpdateProviderFeatures,
  GetProviderPricesLists,
  UpdateProviderPricesLists,
  GetClientFeatures, // Same as GetProviderFeatures, but from customer side
  GetCustomFeatures,
  GetAccountCustomFeatures,
  GetAccountCustomFeatureById,
  AddCustomFeature,
  UpdateCustomFeature,
  UpdateCustomFeatureEnabledValue,
  DeleteCustomFeature,
  GetWebhooks,
  CreateWebhook,
  UpdateWebhook,
  DeleteWebhook,
  GetWebhookEvents,
  EnableAccessAPIDocs,
  DisableAccessAPIDocs,
  GetZapierToken,
  GenerateZapierToken,
  GetPickUpSettings,
  UpdatePickUpSettings,
  RefreshFavicon,
  GetDocumentTypes,
  UpdateDocumentType,
} from '@/api/general-data';

export const getColorScheme = ({ commit, dispatch }) => GetScheme()
  .then(res => {
    commit('SET_COLOR_SCHEME', res);
    return res;
  })
  .catch((e) => {
    console.log('err on getColorScheme', e);
  });

export const setColorScheme = ({ commit, dispatch }, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => SetScheme(data)
    .then(res => {
      commit('SET_COLOR_SCHEME', data);
      return res;
    })
    .catch((e) => {
      console.log('err on setColorScheme', e);
    })
  );

export const setDefaultColorScheme = ({commit}) => {
  commit('SET_COLOR_SCHEME', {theme: 'purple'});
}

export const getFeatures = ({ commit, dispatch }) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetProviderFeatures()
    .then(res => {
      commit('SET_PROVIDER_FEATURES', res);
      return res;
    })
    .catch((e) => {
      console.log('err on getFeatures', e);
    })
  );



export const updateFeatures = ({ commit, dispatch }, features) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateProviderFeatures(features)
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on updateFeatures', e);
    })
  );

export const getProviderPricesLists = ({ commit, dispatch } , id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetProviderPricesLists(id)
    .then(res => {
      // commit('SET_PROVIDER_PRICES_LIST', res);
      return res;
    })
    .catch((e) => {
      console.log('err on getPricesList', e);
    })
);


export const updateProviderPricesLists = ({ commit, dispatch }, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateProviderPricesLists(params.id , params.prices)
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on updatePricesList', e);
    })
  );

export const getClientFeatures = ({ commit, dispatch }) => dispatch('CheckAuth', null, {root: true})
.then(() => GetClientFeatures()
  .then(res => {
    commit('SET_CLIENT_FEATURES', res);
    return res;
  })
  .catch((e) => {
    console.log('err on getFeatures', e);
  })
);

export const getCustomFeatures = ({ commit, dispatch }, id) => dispatch('CheckAuth', null, {root: true})
.then(() => GetCustomFeatures(id)
  .then(res => {
    return res;
  })
  .catch((e) => {
    console.log('err on get custom features', e);
  })
);

export const getAccountCustomFeatures = ({ commit, dispatch }, params) => dispatch('CheckAuth', null, {root: true})
.then(() => GetAccountCustomFeatures(params)
  .then(res => {
    return res;
  })
  .catch((e) => {
    console.log('err on get custom features', e);
  })
);

export const getAccountCustomFeatureById = ({ commit, dispatch }, params) => dispatch('CheckAuth', null, {root: true})
.then(() => GetAccountCustomFeatureById(params)
  .then(res => {
    return res;
  })
  .catch((e) => {
    console.log('err on get custom feature by id', e);
  })
);

export const addCustomFeature = ({ commit, dispatch }, data) => dispatch('CheckAuth', null, {root: true})
.then(() => AddCustomFeature(data)
  .then(res => {
    return res;
  })
  .catch((e) => {
    console.log('err on addCustomFeature', e);
  })
);

export const updateCustomFeature = ({ commit, dispatch }, data) => dispatch('CheckAuth', null, {root: true})
.then(() => UpdateCustomFeature(data)
  .then(res => {
    return res;
  })
  .catch((e) => {
    console.log('err on updateCustomFeature', e);
  })
);

export const updateCustomFeatureEnabledValue = ({ commit, dispatch }, data) => dispatch('CheckAuth', null, {root: true})
.then(() => UpdateCustomFeatureEnabledValue(data)
  .then(res => {
    return res;
  })
  .catch((e) => {
    console.log('err on UpdateCustomFeatureEnabledValue', e);
  })
);

export const deleteCustomFeature = ({ dispatch }, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => DeleteCustomFeature(data)
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on deleteCustomFeature', e);
    })
  );

export const getWebhooks = ({ dispatch }) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetWebhooks()
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on getWebhooks', e);
    })
  );

export const createWebhook = ({ dispatch }, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CreateWebhook(data)
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on createWebhook', e);
    })
  );

export const updateWebhook = ({ dispatch }, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateWebhook(data)
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on updateWebhook', e);
    })
  );

export const deleteWebhook = ({ dispatch }, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => DeleteWebhook(id)
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on deleteWebhook', e);
    })
  );

export const getWebhookHistory = ({ dispatch }, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetWebhookEvents(data)
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on getWebhookHistory', e);
    })
  );


export const showAnnounsBlock = ({commit}) => {
    commit('SHOW_ANNOUNS_BLOCK');
}
  
export const hideAnnounsBlock = ({commit}) => {
    commit('HIDE_ANNOUNS_BLOCK');
}



export const showNotifsBlock = ({commit}) => {
  commit('SHOW_NOTIFS_BLOCK');
}

export const hideNotifsBlock = ({commit}) => {
  commit('HIDE_NOTIFS_BLOCK');
}

export const showRemsBlock = ({commit}) => {
  commit('SHOW_REMS_BLOCK');
}

export const hideRemsBlock = ({commit}) => {
  commit('HIDE_REMS_BLOCK');
}


export const enableAccessAPIDocs = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => EnableAccessAPIDocs()
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on accessAPIDocs', e);
    })
  );


export const disableAccessAPIDocs = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => DisableAccessAPIDocs()
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on accessAPIDocs', e);
    })
  );

export const getZapierToken = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetZapierToken()
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on getZapierToken', e);
    })
  );

export const generateZapierToken = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GenerateZapierToken()
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on generateZapierToken', e);
    })
  );

export const getPickUpSettings = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetPickUpSettings()
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on getPickUpSettings', e);
    })
  );

export const updatePickUpSettings = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
.then(() => UpdatePickUpSettings(data)
  .then(res => {
    return res;
  })
  .catch((e) => {
    console.log('err on getPickUpSettings', e);
  })
);


export const refreshFavicon = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => RefreshFavicon()
    .then(res => {
      return res;
    })
    .catch((e) => {
      console.log('err on refreshFavicon', e);
    })
  );

export const getDocumentTypes = ({dispatch,commit}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetDocumentTypes()
    .then(res => {
      commit('SET_DOCUMENT_TYPES',res.document_types);
      return res.document_types;
    })
    .catch((e) => {
      console.log('err on getDocumentsTypes', e);
    })
  );

export const updateDocumentType = ({dispatch, commit}, data) => dispatch('CheckAuth', null, {root: true})
.then(() => UpdateDocumentType(data)
  .then(res => {
    commit('UPDATE_DOCUMENT_TYPE', res.document_type);
    return res;
  })
  .catch((e) => {
    console.log('err on updateDocumentsType', e);
    throw e;
  })
);
